import './App.css';
import './styles/tokens.css';
import './styles/responsive-mobile.css';

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import TurneroPage from './pages/TurneroPage';
import PacientesPage from './pages/PacientesPage';
import PacienteSubview from './pages/PacienteSubview';
import ProfesionalesPage from './pages/ProfesionalesPage';
import FinanzasPage from './pages/FinanzasPage';
import ProfesionalPrestacionesPage from './pages/ProfesionalPrestacionesPage';
import ConfiguracionPage from './pages/ConfiguracionPage';
import LandingPremiumPage from './pages/LandingPremiumPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Rutas públicas */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />

        {/* Rutas protegidas */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<TurneroPage />} />
          <Route path="/pacientes" element={<PacientesPage />} />
          <Route path="/pacientes/:id" element={<Navigate to="/pacientes" replace />} />
          <Route path="/pacientes/:id/:viewType" element={<PacienteSubview />} />
          <Route path="/profesionales" element={<ProfesionalesPage />} />
          <Route path="/profesionales/:id/prestaciones" element={<ProfesionalPrestacionesPage />} />
          <Route path="/finanzas" element={<FinanzasPage />} />
          <Route path="/prestaciones" element={<Navigate to="/profesionales" replace />} />
          <Route path="/rp" element={<Navigate to="/pacientes" replace />} />
          <Route path="/configuracion" element={<ConfiguracionPage />} />
          <Route path="/premium" element={<LandingPremiumPage />} />
        </Route>

        {/* Cualquier ruta no encontrada redirige al inicio */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
